import type {CoreExportFormat} from '@wix/document-services-types'
import type {DecorationPluginFunction} from '../../types'
import {getVersion as getCoreConverterVersion} from '@wix/document-management-core-converter/version'

export const unpack: DecorationPluginFunction = (componentExport: CoreExportFormat) => {
    componentExport.version = getCoreConverterVersion()
}
